import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParcelQueryRangeDays } from './useParcelQueryRangeDays';
import './parcelQueryRange.css';

/** 「历史包裹查询」菜单右侧常驻标签「N天前妥投」；菜单收起时由 CSS 隐藏 */
const HistoryMenuTag: React.FC = () => {
    const { t } = useTranslation();
    const days = useParcelQueryRangeDays();
    if (days == null) {
        return null;
    }
    return <span className="pqr-menu-tag">{t('parcelQueryRange.menuTag', { days })}</span>;
};

/** 菜单 label：文字 + 标签 */
export const renderHistoryMenuLabel = (label: React.ReactNode): React.ReactNode => (
    <span>
        {label}
        <HistoryMenuTag />
    </span>
);

export default HistoryMenuTag;
